export default defineAppConfig({
  ui: {
    colors: {
      primary: 'purple',
      gray: 'slate',
    },
  },
});
